import React from 'react';
import { CheckCircle, WarningCircle } from '@phosphor-icons/react';
import toast, { Toaster } from 'react-hot-toast';
import './style';

const iconMap = {
  success: <CheckCircle size={32}
    color="#009D64"
    weight="fill" />,
  error: <WarningCircle size={32}
    color="#D92D20"
    weight="fill" />,
};

export const notify = (type, message, { style = {}, className = '', ...rest } = {}) => 
  toast(<div className="label-16 text-black">{message}</div>, {
    icon: iconMap[type],
    duration: 5000,
    position: 'top-center',
    className: `toast-tmt ${className}`,
    ariaProps: {
      'data-class': 'tmt-toast-msg',
    },
    style: {
      paddingLeft: 12,
      paddingRight: 16,
      borderRadius: 60,
      background: '#FDFDFD',
      border: '1px solid #F3F3F3',
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
      ...style,
    },
    ...rest,
  });

const Notifier = (props) => {
  return <Toaster {...props} />;
};

export default Notifier;